import { useTranslation } from 'react-i18next';
import { useNotifications } from '../../api/hooks/notifications/useNotifications';
import { NotificationType } from '../../types/notifications/Notification';
import { getNotificationText } from '../../utils/notifications/notificationText';

export interface BillingIssues {
  count: number;
  messages: string[];
  cardExpiring: boolean;
  paymentDue: boolean;
}

const BILLING_TYPES: NotificationType[] = ['CARD_EXPIRING', 'PAYMENT_REMINDER'];

/**
 * Derives billing "things to fix" from the existing notifications (CARD_EXPIRING,
 * PAYMENT_REMINDER). Reuses the notification list so the thresholds and the admin/owner gate
 * stay defined in one place (the backend) — a USER role simply gets no billing notifications,
 * hence no badge. Drives the subscription nav badge/tooltip and the in-page error highlights.
 */
export const useBillingIssues = (): BillingIssues => {
  const { t } = useTranslation();
  const { notifications } = useNotifications();

  const billing = notifications.filter((n) => BILLING_TYPES.includes(n.type));

  return {
    count: billing.length,
    messages: billing.map((n) => getNotificationText(t, n)),
    cardExpiring: billing.some((n) => n.type === 'CARD_EXPIRING'),
    paymentDue: billing.some((n) => n.type === 'PAYMENT_REMINDER'),
  };
};
